function Modal({
	isOpen,
	children,
	footerContent,
	isShowCancelBtn,
	cancelBtnText,
	onCancel,
	title,
}) {
	return (
		isOpen && (
			<>
				<div className="fixed left-1/2 top-1/2 z-[700] min-w-[80%] -translate-x-1/2 -translate-y-1/2 flex-col rounded-lg bg-white px-[2rem] py-[1.5rem] max-w-[90%]">
					{/* Header */}
					{!!title && (
						<div className="flex justify-center">
							<span className="text-[1.25rem] font-bold">{title}</span>
						</div>
					)}

					{/* Content */}
					<div className="mt-6 flex justify-center text-center text-[1rem] text-[#757575] w-full max-w-full whitespace-pre-wrap">
						{children}
					</div>

					{/* Footer */}
					<div className="mt-8 flex flex-col justify-center gap-4">
						{footerContent}

						{isShowCancelBtn && <button onClick={onCancel}>{cancelBtnText}</button>}
					</div>
				</div>
				<div className="fixed left-0 top-0 z-[600] size-full bg-black opacity-[65%]" />
			</>
		)
	);
}

export default Modal;
